const sanzione1 = [
  {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore:
      "E giusto che vada anche l'annotazione del controllore ?",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00073",
    cliente: { client: 1, nome: "Linee Lecco" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 1",
    },
  },
  {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore:
      "E giusto che vada anche l'annotazione del controllore ? 2",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00075",
    cliente: { client: 1, nome: "Linee Lecco" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 2",
    },
  },
  {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore:
      "E giusto che vada anche l'annotazione del controllore ? 3",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00076",
    cliente: { client: 1, nome: "Linee Lecco" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 3",
    },
  },
];

export default sanzione1;
